import React from 'react';

import styles from './styles/about-02.module.css';

import {ReactComponent as EqualImg} from '../../assets/about02/equal.svg';
import {ReactComponent as PlusImg} from '../../assets/about02/plus.svg';

export default function About02() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <p className={styles.title}>명확함은 무한한 가능성을 이끕니다</p>
                <div className={styles.boxSlogan}>
                    <div className={styles.boxFormula}>
                        <p>Definite</p>
                        <PlusImg />
                        <p>Infinite</p>
                        <EqualImg />
                        <p>Dfinite</p>
                    </div>
                    <div>
                        데이터 인프라와 AI 전문 인력이 부족한 기업들도 AI를 통해<br />
                        혁신을 이루고 지속 가능한 성장을 달성할 수 있도록 지원합니다
                    </div>
                </div>
            </div>
        </div>
    );
}
